import { render, staticRenderFns } from "./SelectAllPermissionsComponent.vue?vue&type=template&id=19180b17&scoped=true&"
import script from "./SelectAllPermissionsComponent.vue?vue&type=script&lang=js&"
export * from "./SelectAllPermissionsComponent.vue?vue&type=script&lang=js&"
import style0 from "./SelectAllPermissionsComponent.vue?vue&type=style&index=0&id=19180b17&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19180b17",
  null
  
)

export default component.exports